import { createSlice } from '@reduxjs/toolkit'
import { setInitialFilterInfo } from '../../../actions'

/* Attributes */
export const attributesFilter = createSlice({
  name: 'attributesFilter',
  initialState: [],
  reducers: {
    updateAttributesFiltersUI: (state, action) => {
      const { payload = {}, meta = {} } = action.payload
      return state.map((attributeObj) => {
        attributeObj = { ...attributeObj }
        if (meta.isNoneClick) {
          attributeObj.checked = false
        } else if (meta.isAllClick) {
          attributeObj.checked = true
        } else if (meta.isOnlyClick) {
          attributeObj.checked = attributeObj.value === payload.value
        } else {
          attributeObj.checked = attributeObj.value === payload.value ? payload.checked : attributeObj.checked
        }
        return { ...attributeObj }
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setInitialFilterInfo, (state, action) => {
      const { payload = {} } = action.payload
      return payload?.ATTRIBUTES || state
    })
  },
})

export const { updateAttributesFiltersUI } = attributesFilter.actions
